const GA_ID = process.env.REACT_APP_GA4_ID;

export function initAnalytics() {
  if (!GA_ID || window.__ga4Loaded) return;
  window.__ga4Loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (window.gtag && GA_ID) window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
}

export function track(event, params = {}) {
  const data = { page_path: window.location.pathname, ...params };
  if (window.gtag && GA_ID) window.gtag("event", event, data);
  if (window.posthog && typeof window.posthog.capture === "function") window.posthog.capture(event, data);
}
